import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SectionLabel from "../components/SectionLabel";
import { getStories } from "../lib/api";

export default function Stories() {
  const [stories, setStories] = useState([]);
  useEffect(() => { getStories().then(setStories).catch(() => {}); }, []);

  return (
    <div data-testid="stories-page">
      <section className="pt-16 lg:pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
          <div className="max-w-3xl space-y-6 fade-up">
            <SectionLabel>The journal</SectionLabel>
            <h1 className="font-serif text-5xl lg:text-7xl font-light text-forest leading-[0.95]">
              Stories from <em className="italic text-terracotta">the field.</em>
            </h1>
            <p className="text-lg text-ink/80 leading-relaxed">
              Real rescues, hard lessons, and the small victories that keep us going. Updates from our shelter, our team, and the animals themselves.
            </p>
          </div>
        </div>
      </section>

      <section className="pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 space-y-16">
          {stories.map((s, i) => (
            <Link
              to={`/stories/${s.id}`}
              key={s.id}
              className={`group grid lg:grid-cols-12 gap-8 items-center ${i % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
              data-testid={`story-row-${s.id}`}
            >
              <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="aspect-[16/10] rounded-[2rem] overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"/>
                </div>
              </div>
              <div className={`lg:col-span-5 space-y-4 ${i % 2 === 1 ? "lg:order-1 lg:pr-8" : "lg:pl-8"}`}>
                <div className="text-xs uppercase tracking-[0.25em] text-terracotta font-bold">{s.tag} · {s.date}</div>
                <h2 className="font-serif text-4xl lg:text-5xl font-light text-forest leading-tight group-hover:text-terracotta transition-colors">
                  {s.title}
                </h2>
                <p className="text-lg text-ink/75 leading-relaxed">{s.excerpt}</p>
                <p className="text-sm text-ink/60">By {s.author}</p>
                <span className="inline-block text-forest font-medium link-underline">Read full story →</span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
